// Should stay in sync with observationReportDocumentsResults.js
export default {
  PASS: 0,
  FAIL: 1,
  COACHING: 2
};
